module.exports = __webpack_public_path__ + "assets/images/ea505b4a3611be3cbd8b3b7d6bd1f156.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/logos/sungevity-logo.png
// module id = 833
// module chunks = 0